import { createFeatureSelector, createSelector } from '@ngrx/store';
import { complianceFeatureKey } from 'src/app/compliance/store/selectors';
import { ComplianceState } from 'src/app/compliance/store/state/compliance.state';

export const complianceFeature = createFeatureSelector<ComplianceState>(complianceFeatureKey);

export const selectAssignees = createSelector(complianceFeature, (state) => state.shippingRequests.assignees);

export const forceReloadGrid = createSelector(complianceFeature, (state) => state.shippingRequests.reloadGrid);

export const isCurrentUserInShippingList = (name: string) =>
    createSelector(
        complianceFeature,
        (state) =>
            state.shippingRequests.assignees.length > 0 &&
            state.shippingRequests.assignees.filter((a) =>
                a.name.toLowerCase().trim().endsWith(name.toLowerCase().trim())
            ).length > 0
    );

export const selectFilter = createSelector(complianceFeature, (state) => state.shippingRequests.filter);

export const selectShippingRequests = createSelector(
    complianceFeature,
    (state) => state.shippingRequests.shippingRequests
);
